import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  menuTrigger: {
    height: '48px',
    minWidth: '48px',
    marginLeft: '0 !important'
  }
});
export default useStyles;